'use strict'

/* global ga */

const SCORE_MIN = 4
const LENGTH_MIN = 8
const CLASS_ACTIV = 'activ'
const ATTRIBUTE_IFRAME_SRC = 'data-iframe-src'

/**
 * Call utils
 * @module utils
 */
// The addScript function will create a 'script' tag by the document.createElement method with 'url' as attribute.

/**
 * @function addScript
 * @param {string} url the script that will be display
 * @return {void}
 */
export function addScript(url) {
  const script = document.createElement('script')
  script.src = url
  // Call/display script in head
  document.head.appendChild(script)
}
// Sends data as plain text using XmlHttpRequest using the 'GET' method
// With the XMLHttpRequest object you can update parts of a web page, without reloading the whole page and it is used to exchange data with a server behind the scenes.

/**
 * @function ajax
 * @param {string} url The data retrieve as plain text
 * @param {string} method get
 * @param {string} data null
 * @return {string} retour
 */
export function ajax(url, method = 'get', data = null) {
  const xhttp = new XMLHttpRequest()
  //  It specifies a function to be executed every time the status of the XMLHttpRequest object changes
  xhttp.onreadystatechange = function () {
    let retour = this
    // When readyState property is 4 and the status property is 200, the response is ready:
    if (this.readyState === 4 && this.status === 200) {
      // retour will contain data retrieve as plain text
      retour = this.responseText
    }

    return retour
  }
  xhttp.open(method, url, true)
  xhttp.send(data)
}

export function getCookie(name) {
  const regex = new RegExp(`(?:; )?${ name }=([^;]*);?`)
  return regex.test(document.cookie) ? decodeURIComponent(RegExp.$1) : null
}

export function getUrlParameter(name) {
  const regex = new RegExp(`[\\?&]${name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')}=([^&#]*)`)
  const results = regex.exec(location.search)
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

export function getLang() {
  const LANG = document.documentElement.lang
  return LANG === 'fr' ? '' : `/${LANG}`
}

export function checkPasswordValidity(string) {
  let count = 0

  if (string) {
    if (string.match(/[a-z]/g)) {
      count++
    }
    if (string.match(/[A-Z]/g)) {
      count++
    }
    if (string.match(/[0-9]/g)) {
      count++
    }
    if (string.match(/[^a-zA-Z0-9]/g)) {
      count++
    }
    if (string.length >= LENGTH_MIN) {
      count++
    }
  }

  return count >= SCORE_MIN
}

export function checkEmailValidity(string) {
  const regex = /^.+@.+$/
  return regex.test(string)
}

export function getContext() {
  const locArray = location.pathname.split('/')
  return locArray.length > 2
    ? location.pathname.split('/')[2]
      + (locArray.length >= 3 ? location.pathname.split('/')[3] : '')
      + (locArray.length >= 4 ? location.pathname.split('/')[4] : '')
    : ''
}

export function handleErrors(response) {
  if (!response.ok) {
    throw Error(response.statusText)
  }
  return response
}

export function initVideo(item) {
  const iframe = document.createElement('iframe')
  const { height, width } = item.getBoundingClientRect()
  const dataset = item.dataset

  iframe.src = `${item.getAttribute(ATTRIBUTE_IFRAME_SRC)}&autoplay=1`
  iframe.width = width
  iframe.height = height
  iframe.setAttribute('allowfullscreen', '')
  item.insertBefore(iframe, item.firstChild)
  item.classList.add(CLASS_ACTIV)

  if (dataset && dataset.eventCategory && dataset.eventAction && dataset.eventLabel) {
    // video:<?= $campsite['video_ctrid'] ?>:<?= $campsite['id'] ?>:null:null
    let eventLabelArray = dataset.eventLabel.split(":");
    let typeProduit = "video";
    let id_annonce = 1 in eventLabelArray ? eventLabelArray[1] : "null";
    let id_annonceur = 2 in eventLabelArray ? eventLabelArray[2] : "null";
    if (window.dataLayer) {
      window.dataLayer.push({
        event: dataset.eventAction,
        event_category: dataset.eventCategory,
        event_label: dataset.eventLabel,
        type_produit: typeProduit,
        id_annonce: id_annonce,
        id_annonceur: id_annonceur,
        id_departement: "null",
        id_thematique: "null",
      });
    }
  }
}

export function closeVideo(item) {
  const iframe = item.getElementsByTagName('iframe').item(0)
  if (iframe) {
    iframe.remove()
  }
  item.classList.remove(CLASS_ACTIV)
}



// WEBPACK FOOTER //
// ./src/apps/Front/private/js/utils/utils.js